function EventScript() {
	const addToSelector = document.querySelector('.tribe-events-calendar-list__add-to');

    if (addToSelector) {
        const dropdownBtn = addToSelector.querySelector('.tribe-events-c-subscribe-dropdown__button');
        const dropdown = addToSelector.querySelector('.tribe-events-c-subscribe-dropdown__content');
        
        dropdownBtn.addEventListener('click', function () {
			if (!dropdownBtn.classList.contains('active')) {
                dropdownBtn.classList.add('active');
                dropdown.classList.add('active-dropdown');
            } else {
                dropdownBtn.classList.remove('active');
                dropdown.classList.remove('active-dropdown');
            }
		});

        document.body.addEventListener('click', (e) => {
            if (e.target !== dropdownBtn && e.target.offsetParent !== dropdownBtn && dropdownBtn.classList.contains('active')) {
                dropdownBtn.classList.remove('active');
                dropdown.classList.remove('active-dropdown');
            }
        });
    }

    /* Datepicker popup's mobile functionality */
	const datepickerBtn = document.querySelector('.tribe-events-c-top-bar__datepicker-button');
	const closeDatePopups = document.querySelectorAll('.datepicker-popup .close-date-popup');
    
    if (datepickerBtn) {
        datepickerBtn.addEventListener('click', function () {
            document.querySelector('.datepicker-popup').classList.add('popup-active');
        });
    }
    
    if (closeDatePopups) {
        closeDatePopups.forEach((closeDatePopup) => {
            closeDatePopup.addEventListener('click', function () {
                document.querySelector('.tribe-events-c-top-bar__datepicker-button').classList.remove('tribe-events-c-top-bar__datepicker-button--open');
                document.querySelector('.datepicker-popup__wrapper').innerHTML = "";
                document.querySelector('.datepicker-popup').classList.remove('popup-active');
            });
		});
    }

}

export default EventScript;
